import { useCurrency } from '@Shared';
import type { MppPolicy } from '@Types/MppPolicy';

export const useMppPolicyLabel = () => {
    const { formatCurrency } = useCurrency();

    const formatPolicyLabel = (policy: MppPolicy | null | undefined): string => {
        if (!policy) return '';
        if (policy.isAboveMaxPolicy || !policy.coverageAmountMax) {
            return `Over ${formatCurrency(policy.coverageAmountMin, 0)}`;
        }
        if (policy.coverageAmountMin === 0) {
            return `Up to ${formatCurrency(policy.coverageAmountMax, 0)}`;
        }
        return `${formatCurrency(policy.coverageAmountMin, 0)} to ${formatCurrency(policy.coverageAmountMax, 0)}`;
    };

    return { formatPolicyLabel };
};
